import api from './api';

/**
 * Inicializa o token CSRF fazendo uma chamada para o endpoint específico
 * Esta função deve ser chamada no início da aplicação
 */
export const initializeCSRF = async (): Promise<void> => {
  try {
    await api.get('/csrf-token/');
  } catch (error) {
    console.error('Erro ao inicializar token CSRF:', error);
  }
};

export default initializeCSRF; 